// src/widgets/ChatDefaultWidget.tsx

import React from 'react';
import { useFabricService } from '../contexts/FabricServiceContext';
import { ConversationWidget } from './ConversationWidget';
import { EventsWidget } from './EventsWidget';
import { AudioVisualization } from '../components/AudioVisualization';
import { InputToolBar } from '../components/InputToolBar';
import { Toggle } from '../components/toggle/Toggle';
import '../components/MainLayout.scss';

interface ChatDefaultWidgetProps {

}

export const ChatDefaultWidget: React.FC<ChatDefaultWidgetProps> = ({

}) => {

  const [activeView, setActiveView] = React.useState<'conversation' | 'events'>('conversation');
  const { conversationFilters, eventFilters } = useFabricService()

  return (
    <div className='conversation-widget-container'>
      <div className='conversation-widget-content'>
        <div className="content-logs">
          <div className="view-toggle-container">
            <Toggle
              defaultValue={activeView}
              labels={['conversation', 'events']}
              values={['conversation', 'events']}
              onChange={(_, value) => setActiveView(value as 'conversation' | 'events')}
              buttonStyle="flush"
              spacing={8}
            />
          </div>
          <div className="content-view">
            {activeView === 'conversation' && (
              <ConversationWidget
                selectedConversationFilters={conversationFilters}
              />
            )}
            {activeView === 'events' && (
              <EventsWidget
                selectedEventFilters={eventFilters}
              />
            )}
          </div>
          <div className="bottom-controls">
            <AudioVisualization />
            <InputToolBar />
          </div>
        </div>
      </div>
    </div>
  );
};